import {GetStaticProps} from "next";
import SimpleMarkdownPageWithHeader from "../../components/common/SimpleMarkdownPageWithHeader";
import ContactUsPanel from "../../components/ContactUsPanel/ContactUsPanel";
import {getStaticPropsForMarkdownPage} from "../../helpers/GetStaticPropsForMarkdownPage";
import {MarkdownMetaDataInterface} from "../../interfaces/MarkdownMetaDataInterface";
import {getSafeLocale} from "../../helpers/LocalizeObject";

function Page({
	              result,
	              markdown: MDXFile,
              }: {
	result: MarkdownMetaDataInterface;
	markdown: any;
}) {
	return (
		<>
			<SimpleMarkdownPageWithHeader mdxFile={MDXFile} metadata={result}/>
			<ContactUsPanel image={result.metadata.metadata.contactImage} contactName={result.metadata.metadata.contactName}/>
		</>
	);
}

export const getStaticProps: GetStaticProps = async (context) => {
	return getStaticPropsForMarkdownPage(
		getSafeLocale(context.locale)!,
		"eigentuemer-immobilien-vermieten"
	);
};

export default Page;
